import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {DataCard, Dialog} from '@bitstillery/common/components/portal'
import type {CollectionProxy} from '@bitstillery/common/lib/collection'
import {$t} from '@bitstillery/common/app'

import {$s} from '@/app'

import {build_offer_card_detail_entries} from '@/components/collection/product/product'

import type {CartOfferItem} from '@/models/cart'

function find_offer_item(artkey: number, collection: CollectionProxy<CartOfferItem>): CartOfferItem | null {
    for (const o of Object.values($s.cart.offer_items)) {
        if (o.artkey === artkey || o.offer_item_artkey === artkey) {
            return o
        }
    }
    for (const row of collection.state.items) {
        if (row.artkey === artkey || row.offer_item_artkey === artkey) {
            return row
        }
    }
    return null
}

export function close_offer_detail_route() {
    const route = m.route.get()
    const qi = route.indexOf('?')
    const path = qi >= 0 ? route.slice(0, qi) : route
    const q = new URLSearchParams(qi >= 0 ? route.slice(qi + 1) : '')
    q.delete('offer_detail')
    const qs = q.toString()
    void m.route.set(qs ? `${path}?${qs}` : path)
}

export function read_offer_detail_artkey_from_route(): number | null {
    const route = m.route.get()
    const qi = route.indexOf('?')
    if (qi < 0) {
        return null
    }
    const q = new URLSearchParams(route.slice(qi + 1))
    const v = q.get('offer_detail')
    if (v == null || v === '') {
        return null
    }
    const n = Number(v)
    return Number.isFinite(n) ? n : null
}

interface OfferItemDetailDialogAttrs {
    collection: CollectionProxy<CartOfferItem>
}

export class OfferItemDetailDialog extends MithrilComponent<OfferItemDetailDialogAttrs> {
    view(vnode: m.Vnode<OfferItemDetailDialogAttrs>) {
        const artkey = read_offer_detail_artkey_from_route()
        if (artkey == null) {
            return null
        }

        const offer_item = find_offer_item(artkey, vnode.attrs.collection)
        if (!offer_item) {
            return (
                <Dialog
                    className='c-offer-item-detail-dialog dialog-portal'
                    onclose={() => close_offer_detail_route()}
                    title={$t('collection.no_results')}
                    type='info'
                >
                    <p className='dialog-missing'>{$t('collection.no_results_retry_loading')}</p>
                </Dialog>
            )
        }

        const bottle_gtin = offer_item.bottle_gtin_code ?? []

        // The uncapped rows: the list card shows at most MAX_LIST_DETAIL_ENTRIES of these;
        // this dialog is where the complete spec lives.
        const detail_data = build_offer_card_detail_entries({
            bottle_gtin,
            offer_item,
            raw_offer_item: offer_item,
        })

        return (
            <Dialog
                className='c-offer-item-detail-dialog dialog-portal'
                onclose={() => close_offer_detail_route()}
                title={offer_item.product_name}
                type='info'
            >
                <DataCard className='details-specs' model={{data: detail_data}} type='unset' variant='extra-dense' />
            </Dialog>
        )
    }
}
